export default __webpack_public_path__ + "static/landing-section-4-f4e51aad20bfe02d00792d56b9d4ab20.png";